<template src="./vehiclecheckview.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import ViewVehicleChecks from "@/pages/vehiclechecks/vehiclecheckviewdata/vehiclecheckviewdata.vue";
  import VueHtml2pdf from "vue-html2pdf";

  export default {
    components: { ViewVehicleChecks, VueHtml2pdf },
    data() {
      return {
        ShowLoader: false,
        VehicleCheckSubmitId: 0,
      };
    },
    mounted() {
      this.$root.$on("GeneratePDF", () => {
        this.GeneratePDF();
      });
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions.Vehicle ||
          !AccountPermissions["Vehicle Checks"] ||
          !AccountPermissions["Vehicle Checks"]["enable"])
      ) {
        this.$router.push("/");
      }
      document.title = pbx_SiteTitle + " - Vehicles Check View";
      this.VehicleCheckSubmitId = this.$route.params.Id;
    },
    methods: {
      LoadProfileData() {
        this.GetVehicleChecksList();
      },
      SearchVehicle() {
        this.GetVehicleChecksList();
      },
      GeneratePDF() {
        this.$refs.html2Pdf.generatePdf({ useCORS: true });
      },
      PDFDownloaded() {
        $("#save_pdf_btn").html("Save as PDF");
      },
    },
  };
</script>
